import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ChatMessageReportStepMute = props => {
  const addMutedUser = useCallback(() => {
    props.addMutedUser(props.userId);
    props.modalCloseHandle();
  }, [props]);
  const addMutedMessage = useCallback(() => {
    props.addMutedMessage(props.id);
    props.modalCloseHandle();
  }, [props]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx("h3", {
        children: "\u975E\u8868\u793A\u5185\u5BB9"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: modalStyles.chatMessageDisplay,
      children: /*#__PURE__*/_jsxs("div", {
        className: modalStyles.chatMessage,
        children: [/*#__PURE__*/_jsx("span", {
          className: modalStyles.username,
          children: props.displayName
        }), /*#__PURE__*/_jsx("span", {
          className: modalStyles.messageContent,
          children: props.postDesc
        })]
      })
    }), /*#__PURE__*/_jsx(Button, {
      borderLight: true,
      fontFixed: true,
      fillWhiteColor: true,
      large: true,
      onClick: addMutedMessage,
      children: "\u3053\u306E\u30B3\u30E1\u30F3\u30C8\u306E\u307F\u975E\u8868\u793A"
    }, "addMutedMessageButton"), /*#__PURE__*/_jsx(Button, {
      borderLight: true,
      fontFixed: true,
      fillWhiteColor: true,
      large: true,
      onClick: addMutedUser,
      children: "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u30B3\u30E1\u30F3\u30C8\u3092\u975E\u8868\u793A"
    }, "addMutedUserButton"), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      borderLight: true,
      onClick: props.modalCloseHandle,
      children: "\u9589\u3058\u308B"
    })]
  });
};
export default ChatMessageReportStepMute;